import React from 'react';
import type { NoteField } from '../../types/disclosure';
interface NotesPanelProps {
  notes: NoteField[];
  showApiNames: boolean;
}
export function NotesPanel({
  notes,
  showApiNames
}: NotesPanelProps) {
  const [primary, ...supporting] = notes;
  return <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]" data-id="element-41" data-mp="3bwl7p9onmmdy">
      <article className="h-full rounded-md border border-blue-200 border-l-4 border-l-blue-600 bg-blue-50/50 px-3 py-2.5" data-id="element-42" data-mp="37wudevzx5o4o">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-blue-800" data-id="element-43" data-mp="2xywpk9lz1tcl">{primary.label}</h3>
        {showApiNames && <p className="font-mono text-[10px] text-blue-500" data-id="element-44" data-mp="2sz1x41mjsvpf">{primary.api}</p>}
        {primary.value ? <p className="mt-1.5 whitespace-pre-line text-[13px] leading-5 text-slate-800" data-id="element-45" data-mp="2oz02gcf8d2jn">{primary.value}</p> : <p className="mt-1.5 text-[13px] italic text-slate-400" data-id="element-46" data-mp="r7x6n8wcq16o">No roadmap notes recorded.</p>}
      </article>

      <div className="grid gap-2 sm:grid-cols-2" data-id="element-47" data-mp="n4r3ia4jcq4f">
        {supporting.map(note => <article key={note.id} className="rounded-md border border-slate-200 bg-white px-3 py-2.5" data-id="element-48" data-mp="37m8dbbr4i50w">
            <h3 className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-49" data-mp="2yn4tu6o1nnlv">{note.label}</h3>
            {showApiNames && <p className="font-mono text-[10px] text-slate-400" data-id="element-50" data-mp="32phzkv2sjlin">{note.api}</p>}
            {note.value ? <p className="mt-1 whitespace-pre-line text-[13px] leading-5 text-slate-800" data-id="element-51" data-mp="3qfcb99bdj41b">{note.value}</p> : <p className="mt-1 text-[13px] italic text-slate-400" data-id="element-52" data-mp="3vccfdeonxwps">Not provided</p>}
          </article>)}
      </div>
    </div>;
}